import {Locales} from "./types"

export const enabledLocales: Locales[] = ["en-GB", "en-US", "de-DE", "de-CH", "fr-FR"]
